import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';

import { HttpClientService } from '../../../shared/services/http-client.service';
import { Util } from '../../../shared/util';

import { Story } from "../../models/story";
import { Task } from "../../models/task";
import { WorkConstants } from '../work.const';

@Injectable()
export class ProjectsService {

  constructor(
    private httpClient: HttpClientService,
  ) { }

  // projects
  loadProjects(id): Observable<any> {
    return this.httpClient.get("user/projects/pageId/" + id);
  }

  getProjectById(projectId): Observable<any> {
    return this.httpClient.get('projects/' + projectId);
  }

  searchProjects(key: string): Observable<any> {
    return this.httpClient.get("user/projects/search?key=" + key);

  }

  //---- Sprint API----//
  /**
   * sprint create
   * @param {number} projectId
   * @param {StoryObject} body
   */
  createSprint(projectId, sprint): Observable<any> {
    let mapObj = {};
    mapObj[WorkConstants.paramsProjectId] = projectId;
    let url = Util.replaceApiUrlParams(WorkConstants.apiCreateSprint, mapObj);
    return this.httpClient.post(url, sprint);
  }

  /**
   * task or story added in sprint
   * @param {number} sprintId
   * @param {DataObject} body
   */
  addTaskToSprint(sprintId: number, body: any) {
    return this.httpClient.post('sprints/' + sprintId + '/addtasks', body);
  }

  /**
   * start or end sprint for given sprint id
   * @param {number} sprintId
   * @param {DataObject} body
   */
  startSprintToggle(sprintId: number, body: any) {
    return this.httpClient.put('sprints/' + sprintId + '/togglestart', body);
  }


  getSprintBundrownChart(sprintId) {
    return this.httpClient.get('sprints/' + sprintId + '/burndown');
  }


  /**
   * get all specific sprints
   * @param {number} projectId
   * @param {number} sprintId
   */
  getSprint(projectId: number, sprintId: number): Observable<any> {
    return this.httpClient.get('projects/' + projectId + '/sprints/' + sprintId);
  }

  /**
   * get all project sprints
   * @param {number} projectId
   */
  getSprints(projectId: number, pageId): Observable<any> {
    // let mapObj = {};
    // mapObj[constnts.projectId]  = projectId;
    // let url  = Util.apiUrlParamReplace(Constants.apiProjectsSprints, mapObj);
    // return this.httpClient.get(url);
    return this.httpClient.get('projects/' + projectId + '/sprints/pageId/' + pageId);
  }

  getSprintFormData(sprintId: number, projectId: number) {
    return this.httpClient.get('sprints/taskformdata/' + sprintId + '/' + projectId);
  }

  /**
   * updated sprint
   * @param {number} projectId
   */
  updateSprint(projectId, sprint): Observable<any> {
    return this.httpClient.put('projects/' + projectId + '/sprints/' + sprint.id, sprint);
  }

  /**
   * updated time sheet
   * @param {number} projectId
   */
  updateTimeSheets(sprintId, taskId, data): Observable<any> {
    return this.httpClient.post('tasks/' + sprintId + '/' + taskId + '/timesheet', data);
  }

  /**
   * get sprint board
   * @param {number} sprintId
   */
  getSprintBoard(sprintId): Observable<any> {
    let mapObj = {};
    mapObj[WorkConstants.paramsSprintId] = sprintId;
    let url = Util.replaceApiUrlParams(WorkConstants.getSprintBoard, mapObj);
    return this.httpClient.get(url);
  }

  /**
   * update sprint board
   * @param {number} sprintId
   */
  updateSprintBoard(sprintId, item, status): Observable<any> {
    let mapObj = {};
    mapObj[WorkConstants.paramsSprintId] = sprintId;
    mapObj[WorkConstants.paramsTaskId] = item.id;
    mapObj[WorkConstants.paramsVersionId] = item.ver_id;
    mapObj[WorkConstants.paramsStatus] = status;
    let url = Util.replaceApiUrlParams(WorkConstants.updateSprintBoard, mapObj);
    return this.httpClient.put(url, {}, true);
  }


  //---- Story API----//
  /**
   * story create api call
   * @param {number} projectId
   * @param {StoryObject} body
   * return Observable<any> object
   */
  createStory(projectId: number, body) {
    return this.httpClient.post('projects/' + projectId + '/stories', body);
  }

  /**
   * get all stories in project
   */
  getStories(projectId: number, pageId): Observable<any> {
    return this.httpClient.get('projects/' + projectId + '/backlog/pageId/' + pageId);
  }

  //----Task API----//
  /**
   * create task api call
   * @param {number} projectId
   * @param {StoryObject} body
   * return Observable<any> object
   */
  createTask(projectId: number, body): Observable<any> {
    return this.httpClient.post('projects/' + projectId + '/tasks', body);
  }

  /**
   * get task details by task id
   * @param {number} taskId
   */
  getTask(taskId) {
    return this.httpClient.get('tasks/' + taskId).map(res => new Task(res.data));
  }

  /**
   * get task details by task id
   * @param {number} taskId
   */
  getStoryWithTask(taskId) {
    return this.httpClient.get('view/tasks/' + taskId).map(res => new Task(res.data));
  }

  /**
   * get all tasks specific for story
   * @param {number} storyId
   */
  getSubTasks(storyId: number) {
    return this.httpClient.get('tasks/' + storyId + '/subtasks');
  }

  getTaskFormData(projectId: number, taskType: number) {
    return this.httpClient.get('tasks/formdata/' + taskType + '/' + projectId);
  }

  /**
   * kauhsalya
   * 2017-09-14
   * get the task category
   */
  getTaskCategory() {
    let body = {};
    return this.httpClient.post('tasks/taskCatagory', body);
  }

  /**
   * get task time sheets
   * @param {number} sprintId
   * @param {number} taskId
   */
  getTaskTimeSheet(taskId, sprintId, pageId): Observable<any> {
    let mapObj = {};
    mapObj[WorkConstants.paramsTaskId] = taskId;
    mapObj[WorkConstants.paramsSprintId] = sprintId;
    let url = Util.replaceApiUrlParams(WorkConstants.getTimeSheets, mapObj);
    //kauhsalya 2017-08-04 , add page id to url
    url = url+'/'+WorkConstants.paramsPageId+'/'+ pageId;
    return this.httpClient.get(url);
  }

  /**
   * save edited time for task
   * @param {number} sprintId
   * @param {number} taskId
   * @param {number} timeSheet
   */
  editTimeSheet(dataObject, body): Observable<any> {
    let mapObj = {};
    mapObj[WorkConstants.paramsTaskId] = dataObject.taskId;
    mapObj[WorkConstants.paramsSprintId] = dataObject.sprintId;
    mapObj[WorkConstants.paramsVersionId] = dataObject.timeSheet.task_version_id;
    mapObj[WorkConstants.paramsTimeSheetId] = dataObject.timeSheet.id;
    let url = Util.replaceApiUrlParams(WorkConstants.editTimeSheets, mapObj);
    return this.httpClient.put('timesheet/' + dataObject.timeSheet.id + '/task/' + dataObject.taskId + '/sprint/' + dataObject.sprintId + '/version/' + dataObject.timeSheet.task_version_id, body);

  }

  /**
   * get project sprint time line
   * @param {number} projectId
   */
  getTimeLine(projectId): Observable<any> {
    let mapObj = {};
    mapObj[WorkConstants.paramsProjectId] = projectId;
    let url = Util.replaceApiUrlParams(WorkConstants.projectTimeLine, mapObj);
    return this.httpClient.get(url);
  }

  /**
   * edit task or story
   * @param {number} taskType
   * @param {number} taskId
   * @param {any} body
   */
  editTask(task: Story, body: any) {
    let mapObj = {};
    mapObj[WorkConstants.paramsTaskType] = task.type;
    mapObj[WorkConstants.paramsTaskId] = task.id;
    let url = Util.replaceApiUrlParams(WorkConstants.apiEditTask, mapObj);
    return this.httpClient.put(url, body);
  }

  editTaskTimes(taskId: number, body: any) {
    let mapObj = {};
    mapObj[WorkConstants.paramsTaskId] = taskId;
    let url = Util.replaceApiUrlParams(WorkConstants.apiEditTaskTimes, mapObj);
    return this.httpClient.patch(url, body);
  }

  /**
   * delete time sheets
   * @param {number} timesheetId
   */
  deleteTaskTimes(timesheetId: number) {
    let mapObj = {};
    mapObj[WorkConstants.paramsTimeSheetId] = timesheetId;
    let url = Util.replaceApiUrlParams(WorkConstants.deleteTimeSheet, mapObj);
    return this.httpClient.delete(url);
  }

  /**
   * get project documents
   * @param {number} timesheetId
   */
  getDocuments(projectId: number) {
    let mapObj = {};
    mapObj[WorkConstants.paramsProjectId] = projectId;
    let url = Util.replaceApiUrlParams(WorkConstants.getProjectId, mapObj);
    return this.httpClient.get(url);
  }

  editTaskAttachment(attachmentId: number, taskId: number, body: any) {
    return this.httpClient.put('attachments/' + attachmentId + '/' + taskId, body);
  }

  deleteTaskAttachment(attachmentId: number) {
    return this.httpClient.delete('attachments/' + attachmentId);
  }

  getProjectDetails(projectId) {
    return this.httpClient.get('projects/' + projectId + '/details');
  }


  //----File Upload API----//
  /**
   * upload file
   * @param {File} file
   * return Observable<any> object
   */
  uploadFile(file) {
    return this.httpClient.fileUpload('files/upload', file);
  }

  /**
   * remove upload file
   * @param {string} fileName
   * return Observable<any> object
   */
  removeFile(fileName) {
    return this.httpClient.delete('files/remove?f=' + fileName);
  }

  //----Employee Details API----//
  /**
   * get profile image
   * @param {number} employeeNumber
   */
  getEmployeeImage(employeeNumber: number) {
    return this.httpClient.get('files/profileimage/' + employeeNumber);
  }

  getAuthUserDetials() {
    return this.httpClient.get('auth/user');
  }

  //----START SETTING----//

  /* Components API */
  assignComponentToProject(projectId, components): Observable<any> {
    return this.httpClient.post('projects/' + projectId + '/components', components);
  }

  removeComponents(projectId: number, componentId: number) {
    return this.httpClient.delete('projects/' + projectId + '/components/' + componentId);
  }

  getComponents(): Observable<any> {
    return this.httpClient.get("components");
  }

  getProjectComponents(projectId: number): Observable<any> {
    return this.httpClient.get('projects/' + projectId + '/components');
  }

  /* Version API */
  createProjectVersion(version, projectId): Observable<any> {
    return this.httpClient.post('projects/' + projectId + '/versions', version);
  }

  editVersion(projectId: number, versionId: number, body: any) {
    return this.httpClient.put('projects/' + projectId + '/versions/' + versionId, body);
  }

  deleteProjectVersions(projectId, versionId): Observable<any> {
    return this.httpClient.delete('projects/' + projectId + '/versions/' + versionId);
  }

  getProjectVersion(projectId: any): Observable<any> {
    return this.httpClient.get('projects/' + projectId + '/versions');
  }

  /* Module API */
  createModule(projectId: number, body: any) {
    return this.httpClient.post('projects/' + projectId + '/modules', body);
  }

  editModule(projectId: number, moduleId: number, body) {
    return this.httpClient.put('projects/' + projectId + '/modules/' + moduleId, body);
  }

  deleteModule(projectId: number, moduleId: number) {
    return this.httpClient.delete('projects/' + projectId + '/modules/' + moduleId);
  }

  getModules(projectId: number) {
    return this.httpClient.get('projects/' + projectId + '/modules');
  }

  /*
  * kaushalya
  * get project relese and review details according to the date range
  */
  getProjectReviewAndReleseDetailsAccordingToDateRange(body: any) {
    return this.httpClient.post('timeline/getReleaseTimeLine', body);
  }

  /**
   * kauhsalya
   * get all the project according to client or not
   */
  loadAllProjects(): Observable<any> {
    return this.httpClient.get("user/allProjects");
  }
  //----END SETTING----//

}



// WEBPACK FOOTER //
// ./src/app/modules/work/services/projects.service.ts